/* istanbul ignore file */
import { useHistory } from 'react-router-dom';

export const useGo = (path: string): (({ state }?: { state: unknown }) => void) => {
  const history = useHistory();
  return (value?: { state: unknown }) => history.push(path, value?.state);
};
